/**
 * State used in rendering SkeletonItem
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
